import { render } from "./dltdan.vue?vue&type=template&id=2fd51b82&scoped=true"
import script from "./dltdan.vue?vue&type=script&lang=js"
export * from "./dltdan.vue?vue&type=script&lang=js"

import "./dltdan.vue?vue&type=style&index=0&id=2fd51b82&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd51b82"]])

export default __exports__